<template>
<div class="pageContent" align="center">
    <!-- 头部 -->
    <div>
         <!-- 1：未注册会员 -->
         <div v-if="PageNum=='0'" >
                <img src="../../../static/portal/card.png" style="width:25%;margin-top:1.0rem "  /> 
                <div  style="position: relative;">
                        <div style="font-size:0.38rem;color:#4e4e4e; ">新会员立送<a style="color:#ff775c;">￥50</a>元代金券</div>
                </div>
                <div style="font-size:0.28rem; line-height:26px">您即将成为格林数字卡会员 </div>
                <div style="font-size:0.28rem;line-height:26px">手机号为{{this.UserPhone}}</div>
                <div>
                  <input  type="button" v-on:click="GoJoin"  style="letter-spacing:0.1rem;width:90%; height:0.8rem; background-color:#09bb07; border-radius:5px;border-width:0;font-size:16px;color: #f5f5f5 ;margin-top: 0.28rem  "  value="马上加入" /> 
                </div>
         </div>
         <!-- 2.是会员，未绑定 -->
          <div v-if="PageNum=='1'" >
                <img src="../../../static/portal/ok.png" style="width:10%;margin-top:1.0rem " />  
                <div style="font-size:0.36rem;color:#4e4e4e;margin-top:0.2rem ">您已成功连接网络</div>
                <div style="font-size:0.28rem;line-height:26px">快来下载APP,更有优惠等你拿 </div>
         </div>
         <!-- 3.是会员，未超过1000积分 -->
          <div v-if="PageNum=='2'" >
                <img src="../../../static/portal/ok.png" style="width:10%;margin-top:1.0rem " />  
                <div style="font-size:0.36rem;color:#4e4e4e;margin-top:0.2rem">您已成功连接网络</div>
                <div style="font-size:0.28rem;line-height:26px">积分更有好礼拿 </div>
         </div>
         <!-- 4.是会员，超过1000积分 -->
          <div v-if="PageNum=='3'" >
                <img src="../../../static/portal/ok.png" style="width:10%;margin-top:1.0rem " />  
                <div style="font-size:0.36rem;color:#4e4e4e;margin-top:0.2rem">您已成功连接网络</div>
                <div style="font-size:0.28rem;line-height:26px">您已经拥有较多积分啦,可以去兑换礼品</div>
         </div>
    </div>

    <!-- 中间 -->
     <div align="center" style="margin-top:1.0rem">
           <!-- 1：未注册会员 -->
         <div v-if="PageNum=='0'" >
                 <div style="margin-top:0.2rem; margin-left:0.4rem;margin-right:0.4rem; background-color:#f7f7f7; height:2.4rem;  ">
                    <img src="../../../static/portal/downloadapp.png" style="float:left;width:28%;margin-left:0.1rem;margin-top:0.3rem; " />  
                    <div style="width:2.6rem; text-align:left;float:left;margin-left:0.1rem;margin-top:0.2rem;"> 
                          <div style="font-size:0.36rem; line-height:26px;color:#4e4e4e; font-weight:bold">格林APP下载</div>
                          <div style="font-size:0.16rem; line-height:22px"> 会员首次登录:</div>
                          <div style="font-size:0.16rem; line-height:22px"> 得 <a style="color:#ff775c;">¥100</a>住房大礼包</div>
                          <div style="font-size:0.16rem; line-height:22px"><a style="color:#ff775c;">¥99.8</a>特惠房抢先订</div>
                     </div>
                     <div style="text-align:right;margin-top:0.3rem;margin-right:0.1rem;">
                       <a  v-on:click="GoDownload" style="padding:0 13px;weight:2.8rem;line-height:0.6rem; height:0.6rem; background-color:#ef6a31;border-color:#ef6a31; font-size:14px;color: #f5f5f5; margin-top:0.85rem;display:inline-block "  > 立即下载</a>
                        <!-- <input  type="button"  style="width:20%; height:0.6rem; background-color:#ef6a31;border-color:#ef6a31; font-size:12px;color: #f5f5f5 ;  margin-top:0.7rem; "  value="立即下载" />  -->
                     </div>
                 </div>
                <div style="margin-top:0.0rem; margin-left:0.4rem;margin-right:0.4rem; background-color:#f7f7f7; height:2.1rem; "> 
                    <img src="../../../static/portal/free.png" style="float:left;width:28%;margin-left:0.1rem;margin-top:0.2rem; " />  
                    <div style="width:2.6rem; text-align:left;float:left;margin-left:0.1rem;margin-top:0.2rem;"> 
                          <div style="font-size:0.36rem; line-height:26px;color:#4e4e4e; font-weight:bold">免费住格林</div>
                          <div style="font-size:0.16rem; line-height:22px">会员免费抽奖</div>
                          <div style="font-size:0.16rem; line-height:22px">万元现金等你来赢</div>
                     </div>
                     <div style="text-align:right;;margin-top:0.2rem;margin-right:0.1rem;">
                       <a v-on:click="GoFree"  style="padding:0 15px;weight:2.8rem;line-height:0.6rem; height:0.6rem; background-color:#ef6a31;border-color:#ef6a31; font-size:14px;color: #f5f5f5; margin-top:0.7rem;display:inline-block "  >  去 看 看</a>
                     </div>
                </div>
                <div style="margin-top:0.0rem; margin-left:0.4rem;margin-right:0.4rem; background-color:#f7f7f7; height:2.1rem; "> 
                      <img src="../../../static/portal/168Market.png" style="float:left;width:28%;margin-left:0.1rem;margin-top:0.2rem; " />  
                      <div style="width:2.6rem; text-align:left;float:left;margin-left:0.1rem;margin-top:0.2rem;"> 
                              <div style="font-size:0.36rem; line-height:26px;color:#4e4e4e; font-weight:bold">168商城</div>
                              <div style="font-size:0.16rem; line-height:22px">名牌低价</div>
                              <div style="font-size:0.16rem; line-height:22px">2倍差距赔付</div>
                        </div>
                        <div style="text-align:right;;margin-top:0.2rem;margin-right:0.1rem;">
                          <a v-on:click="Go168Matker"   style="padding:0 15px;weight:2.8rem;line-height:0.6rem; height:0.6rem; background-color:#ef6a31;border-color:#ef6a31; font-size:14px;color: #f5f5f5; margin-top:0.6rem;display:inline-block "  >去 逛 逛</a>
                        </div>
                </div>
         </div>
          <!-- 2.是会员，未绑定 -->
          <div v-if="PageNum=='1'" >
               <div style="margin-top:0.2rem; margin-left:0.4rem;margin-right:0.4rem; background-color:#f7f7f7; height:2.4rem;  ">
                    <img src="../../../static/portal/downloadapp.png" style="float:left;width:28%;margin-left:0.1rem;margin-top:0.3rem; " />  
                    <div style="width:2.6rem; text-align:left;float:left;margin-left:0.1rem;margin-top:0.2rem;"> 
                          <div style="font-size:0.36rem; line-height:26px;color:#4e4e4e; font-weight:bold">格林APP下载</div>
                          <div style="font-size:0.16rem; line-height:22px"> 会员首次登录:</div>
                          <div style="font-size:0.16rem; line-height:22px"> 得 <a style="color:#ff775c;">¥100</a>住房大礼包</div>
                          <div style="font-size:0.16rem; line-height:22px"><a style="color:#ff775c;">¥99.8</a>特惠房抢先订</div>
                     </div>
                     <div style="text-align:right;margin-top:0.3rem;margin-right:0.1rem;">
                       <a v-on:click="GoDownload" style="padding:0 13px;weight:2.8rem;line-height:0.6rem; height:0.6rem; background-color:#ef6a31;border-color:#ef6a31; font-size:14px;color: #f5f5f5; margin-top:0.85rem;display:inline-block "  > 立即下载</a>
                        <!-- <input  type="button"  style="width:20%; height:0.6rem; background-color:#ef6a31;border-color:#ef6a31; font-size:12px;color: #f5f5f5 ;  margin-top:0.7rem; "  value="立即下载" />  -->
                     </div>
                 </div>
                <div style="margin-top:0.0rem; margin-left:0.4rem;margin-right:0.4rem; background-color:#f7f7f7; height:2.1rem; "> 
                      <img src="../../../static/portal/168Market.png" style="float:left;width:28%;margin-left:0.1rem;margin-top:0.2rem; " />  
                      <div style="width:2.6rem; text-align:left;float:left;margin-left:0.1rem;margin-top:0.2rem;"> 
                              <div style="font-size:0.36rem; line-height:26px;color:#4e4e4e; font-weight:bold">168商城</div>
                              <div style="font-size:0.16rem; line-height:22px">名牌低价</div>
                              <div style="font-size:0.16rem; line-height:22px">2倍差距赔付</div>
                        </div>
                        <div style="text-align:right;;margin-top:0.2rem;margin-right:0.1rem;">
                          <a v-on:click="Go168Matker"   style="padding:0 15px;weight:2.8rem;line-height:0.6rem; height:0.6rem; background-color:#ef6a31;border-color:#ef6a31; font-size:14px;color: #f5f5f5; margin-top:0.7rem;display:inline-block "  >去 逛 逛</a>
                        </div>
                </div>
                <div style="margin-top:0.0rem; margin-left:0.4rem;margin-right:0.4rem; background-color:#f7f7f7; height:2.1rem; "> 
                    <img src="../../../static/portal/free.png" style="float:left;width:28%;margin-left:0.1rem;margin-top:0.2rem; " />  
                    <div style="width:2.6rem; text-align:left;float:left;margin-left:0.1rem;margin-top:0.2rem;"> 
                          <div style="font-size:0.36rem; line-height:26px;color:#4e4e4e; font-weight:bold">免费住格林</div>
                          <div style="font-size:0.16rem; line-height:22px">会员免费抽奖</div>
                          <div style="font-size:0.16rem; line-height:22px">万元现金等你来赢</div>
                     </div>
                     <div style="text-align:right;;margin-top:0.2rem;margin-right:0.1rem;">
                       <a v-on:click="GoFree" style="padding:0 15px;weight:2.8rem;line-height:0.6rem; height:0.6rem; background-color:#ef6a31;border-color:#ef6a31; font-size:14px;color: #f5f5f5; margin-top:0.7rem;display:inline-block "  >  去 看 看</a>
                     </div>
                </div>
         </div>
         <!-- 3.是会员，未超过1000积分 -->
          <div v-if="PageNum=='2'" >
                  <div style="margin-top:0.2rem; margin-left:0.4rem;margin-right:0.4rem; background-color:#f7f7f7; height:2.4rem;  ">
                    <img src="../../../static/portal/downloadapp.png" style="float:left;width:28%;margin-left:0.1rem;margin-top:0.3rem; " />  
                    <div style="width:2.6rem; text-align:left;float:left;margin-left:0.1rem;margin-top:0.2rem;"> 
                          <div style="font-size:0.36rem; line-height:26px;color:#4e4e4e; font-weight:bold">格林APP下载</div>
                          <div style="font-size:0.16rem; line-height:22px"> 会员首次登录:</div>
                          <div style="font-size:0.16rem; line-height:22px"> 得 <a style="color:#ff775c;">¥100</a>住房大礼包</div>
                          <div style="font-size:0.16rem; line-height:22px"><a style="color:#ff775c;">¥99.8</a>特惠房抢先订</div>
                     </div>
                     <div style="text-align:right;margin-top:0.3rem;margin-right:0.1rem;">
                       <a  v-on:click="GoDownload" style="padding:0 13px;weight:2.8rem;line-height:0.6rem; height:0.6rem; background-color:#ef6a31;border-color:#ef6a31; font-size:14px;color: #f5f5f5; margin-top:0.85rem;display:inline-block "  > 立即下载</a>
                        <!-- <input  type="button"  style="width:20%; height:0.6rem; background-color:#ef6a31;border-color:#ef6a31; font-size:12px;color: #f5f5f5 ;  margin-top:0.7rem; "  value="立即下载" />  -->
                     </div>
                 </div>
                <div style="margin-top:0.0rem; margin-left:0.4rem;margin-right:0.4rem; background-color:#f7f7f7; height:2.1rem; "> 
                      <img src="../../../static/portal/168Market.png" style="float:left;width:28%;margin-left:0.1rem;margin-top:0.2rem; " />  
                      <div style=" width:2.6rem; text-align:left;float:left;margin-left:0.1rem;margin-top:0.2rem;"> 
                              <div style="font-size:0.36rem; line-height:26px;color:#4e4e4e; font-weight:bold">168商城</div>
                              <div style="font-size:0.16rem; line-height:22px">名牌低价</div>
                              <div style="font-size:0.16rem; line-height:22px">2倍差距赔付</div>
                        </div>
                        <div style="text-align:right;;margin-top:0.2rem;margin-right:0.1rem;">
                          <a v-on:click="Go168Matker"   style="padding:0 15px;weight:2.8rem;line-height:0.6rem; height:0.6rem; background-color:#ef6a31;border-color:#ef6a31; font-size:14px;color: #f5f5f5; margin-top:0.7rem;display:inline-block "  >去 逛 逛</a>
                        </div>
                </div>
                <div style="margin-top:0.0rem; margin-left:0.4rem;margin-right:0.4rem; background-color:#f7f7f7; height:2.1rem; "> 
                    <img src="../../../static/portal/Kmoney.png" style="float:left;width:28%;margin-left:0.1rem;margin-top:0.2rem; " />  
                    <div style=" width:2.6rem; text-align:left;float:left;margin-left:0.1rem;margin-top:0.2rem;"> 
                          <div style="font-size:0.36rem; line-height:26px;color:#4e4e4e; font-weight:bold">分享赚K币</div>
                          <div style="font-size:0.16rem; line-height:22px">邀好友关注微信</div>
                          <div style="font-size:0.16rem; line-height:22px">无限量K币送不停</div>
                     </div>
                     <div style="text-align:right;;margin-top:0.2rem;margin-right:0.1rem;">
                       <a  v-on:click="GoKMoeny"  style="padding:0 15px;weight:2.8rem;line-height:0.6rem; height:0.6rem; background-color:#ef6a31;border-color:#ef6a31; font-size:14px;color: #f5f5f5; margin-top:0.6rem;display:inline-block "  >  去 看 看</a>
                     </div>
                </div>
         </div>
         <!-- 4.是会员，超过1000积分 -->
          <div v-if="PageNum=='3'" >
                  <div style="margin-top:0.2rem; margin-left:0.4rem;margin-right:0.4rem; background-color:#f7f7f7; height:2.1rem;  ">
                    <img src="../../../static/portal/present.png" style="float:left;width:28%;margin-left:0.1rem;margin-top:0.3rem; " />  
                    <div style="text-align:left;float:left;margin-left:0.1rem;margin-top:0.2rem;"> 
                          <div style="font-size:0.36rem; line-height:26px;color:#4e4e4e; font-weight:bold">积分换礼</div>
                          <div style="font-size:0.16rem; line-height:22px">积分就能换好礼</div>
                          <div style="font-size:0.16rem; line-height:22px">海量代金券等你拿</div>
                     </div>
                     <div style="text-align:right;margin-top:0.3rem;margin-right:0.1rem;">
                       <a  v-on:click="GoPresent"   style="padding:0 15px;weight:2.8rem;line-height:0.6rem; height:0.6rem; background-color:#ef6a31;border-color:#ef6a31; font-size:14px;color: #f5f5f5; margin-top:0.7rem;display:inline-block "  > 去 看 看</a>
                        <!-- <input  type="button"  style="width:20%; height:0.6rem; background-color:#ef6a31;border-color:#ef6a31; font-size:12px;color: #f5f5f5 ;  margin-top:0.7rem; "  value="立即下载" />  -->
                     </div>
                 </div>
                <div style="margin-top:0.0rem; margin-left:0.4rem;margin-right:0.4rem; background-color:#f7f7f7; height:2.1rem; "> 
                      <img src="../../../static/portal/168Market.png" style="float:left;width:28%;margin-left:0.1rem;margin-top:0.2rem; " />  
                      <div style="text-align:left;float:left;margin-left:0.1rem;margin-top:0.2rem;"> 
                              <div style="font-size:0.36rem; line-height:26px;color:#4e4e4e; font-weight:bold">168商城</div>
                              <div style="font-size:0.16rem; line-height:22px">名牌低价</div>
                              <div style="font-size:0.16rem; line-height:22px">2倍差距赔付</div>
                        </div>
                        <div style="text-align:right;;margin-top:0.2rem;margin-right:0.1rem;">
                          <a v-on:click="Go168Matker"  style="padding:0 15px;weight:2.8rem;line-height:0.6rem; height:0.6rem; background-color:#ef6a31;border-color:#ef6a31; font-size:14px;color: #f5f5f5; margin-top:0.6rem;display:inline-block "  >去 逛 逛</a>
                        </div>
                </div>
                <div style="margin-top:0.0rem; margin-left:0.4rem;margin-right:0.4rem; background-color:#f7f7f7; height:2.1rem; "> 
                    <img src="../../../static/portal/free.png" style="float:left;width:28%;margin-left:0.1rem;margin-top:0.2rem; " />  
                      <div style="width:2.6rem; text-align:left;float:left;margin-left:0.1rem;margin-top:0.2rem;"> 
                          <div style="font-size:0.36rem; line-height:26px;color:#4e4e4e; font-weight:bold">免费住格林</div>
                          <div style="font-size:0.16rem; line-height:22px">会员免费抽奖</div>
                          <div style="font-size:0.16rem; line-height:22px">万元现金等你来赢</div>
                     </div>
                     <div style="text-align:right;;margin-top:0.2rem;margin-right:0.1rem;">
                       <a v-on:click="GoFree"  style="padding:0 15px;weight:2.8rem;line-height:0.6rem; height:0.6rem; background-color:#ef6a31;border-color:#ef6a31; font-size:14px;color: #f5f5f5; margin-top:0.7rem;display:inline-block "  >  去 看 看</a>
                     </div>
                </div>
         </div>
    </div>
     
      <!--线条-->
    <hr style="border:none; border-top:1px solid #F1F1F1;"></hr>
    <!-- 尾部 -->
     <div style="margin-top:0.4rem; ">
         <div style="line-height:28px;font-size:12px;color: #999999;">格林酒店  只需感受</div>
         <div style="line-height:28px;font-size:10px;color: #cccccc;">格林豪泰酒店（中国）有限公司版权所有 </div>
         <div style="line-height:18px;font-size:10px;color: #cccccc;"><a href="http://beian.miit.gov.cn">沪ICP备14035076号</a></div>
    </div>
</div>
</template>

<style lang="less" scoped>
// @import "../../assets/theme.less";

.bottomstyle {
    position: fixed;
    top: 20%;
    width: 100%;
    z-index: 1002;
    left: 10%;
    }

// .mu-bottom-nav-shift {
//       background-color: #FFF;
//       .mu-buttom-item-wrapper {
//         .bottomIconColor {
//           color: @primaryColor;
//         }
//         .mu-bottom-item-text {
//           color: @primaryColor;
//         }
//       }
//     }
.title{
  color:#363636;
  font-size:0.4rem;
  margin-top: 0.5rem;
  font-weight:bold;
  margin-bottom:0.5rem;
  border-bottom:2px solid #E3313C;
  width:1.6rem;
} 

</style>



<script>
import api from "../../api";
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
import loadListTail from "../../components/loadListTail";
import Scroll from "../../utils/loading";
export default {
  data() {
    return {
         UserPhone: '',
         PageNum:0, // 0 未注册  1：已注册 未绑定  2：积分1000以内 3：积分1000以上 
    };
  },
  activated() {
           if ( this.$route.query.usr!= undefined )
                {
                    this.UserPhone=this.$route.query.usr; //获取转入参数 手机号码
                }
           this.init();
  },
  methods: {
    ...mapMutations([
        'setG_UserInfo', 'setG_loginInfo'
        ]), 

    init() {
        //  根据手机号码判断是否是会员 ，会员返回积分 ，并且给PageNum赋值
        var params = new this.URLSearchParam();
        params.append('phone', this.UserPhone);
        this.$http.post(api.WifiPortal(), params.toParam()).then((res) => {

          console.log(res)
          if (res.Result == true) {
             this.PageNum=res.Data;
         }
         else
         {
             this.PageNum=0;
         }
         })
    },

      // 登入页面
        GoJoin() {
            this.$router.push({ path: '/user/Login?sourcecode=wifi&activeTab=tab2&usr='+this.UserPhone });
            },
  


      // 跳转到下载页面
        GoDownload() {
            this.$router.push({ path: '/applink.htm?sourcecode=wifi' });
            },

       // 跳转到168商城
        Go168Matker() {
            // /this.$router.push({ path: 'https://www.168.com/index.php/mobile/#home' });
                window.location.href = 'https://www.168.com/index.php/mobile/#home';
            },

      // 跳转到免费住格林
        GoFree() {
            this.$router.push({ path: '/Activity/SummerHolidayIndex?sourcecode=wifi' });
            },
 
     // 跳转到代金券页面
        GoPresent() {
            this.$router.push({ path: '/wallet/voucher?sourcecode=wifi&activeTab=tab5' });
            },
  
      //分享就能赚K币的活动引导链接：
      GoKMoeny() {
            this.$router.push({ path: '/ActivityProject/ScanCompetition/index.html?sourcode=wifi' });
            },
 




    // 后退一页
    goback() {
      javascript: history.go(-1);
    },

    // 弹出层
    showToast () {
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => { this.toast = false }, 2000)
    },
    hideToast () {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },
  }
};
</script>


// WEBPACK FOOTER //
// Wifiportal.vue?6db09ad6